export enum PermissionType {
    customerUser = 'customer.user',
    customerAdmin = 'customer.admin',
    portalUser = 'portal.user',
    portalAdmin = 'portal.admin'
}